module.exports = __webpack_public_path__ + "img/w3_translate_dark.29817a95.png";